module.exports = __webpack_public_path__ + "img/img5.ff61728e.svg";